// extracted by mini-css-extract-plugin
var _1 = "ZlwOF";
var _2 = "vCKkX";
var _3 = "j7MFW";
export { _1 as "pdf-document", _2 as "placeholder", _3 as "viewer" }
